import React, { Component, ComponentType } from "react";
import { connect } from "react-redux";

import { getPhotoUsed } from "./action";
import { MediaPhotoUsedSetAction } from "./types";
import { RootState, MediaPhoto } from "../../types";

type StateProps = {
  data: MediaPhoto[] | null;
};

type DispatchProps = {
  search: (
    refresh?: boolean,
    query?: string
  ) => Promise<MediaPhotoUsedSetAction | { data: MediaPhoto[] | null }>;
};

type Props = {
  // @TODO add typing when typing components
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Layout: ComponentType<any>;
  onSelect: (image: MediaPhoto) => void;
} & DispatchProps &
  StateProps;

type State = {
  error: null;
  loading: boolean;
  refreshing: boolean;
  query?: string;
};

class SearchImageUsed extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      refreshing: false,
    };
  }

  componentDidMount(): void {
    this.reFetch(true);
  }

  reFetch = (refresh: boolean, callback?: () => void): void => {
    const { search } = this.props;
    const { refreshing, loading, query } = this.state;
    if (refreshing || loading) {
      return;
    }

    this.setState({ refreshing: refresh, loading: !refresh }, async () => {
      try {
        await search(refresh, query);
        this.setState({ refreshing: false, loading: false, error: null });
        callback?.();
      } catch (error) {
        this.setState({ loading: false, refreshing: false, error: error });
      }
    });
  };

  render = (): JSX.Element => {
    const { Layout, data, onSelect } = this.props;
    const { loading, error, refreshing } = this.state;
    return (
      <Layout
        error={error}
        loading={loading}
        refreshing={refreshing}
        data={data}
        onSelect={onSelect}
        reFetch={this.reFetch}
      />
    );
  };
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    data: state.media.photoUsed,
  };
};

const mapDispatchToProps = {
  search: getPhotoUsed,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchImageUsed);
